<button mat-icon-button (click)="handleClick($event)" [disabled]="loading">
  <mat-progress-spinner
    *ngIf="loading"
    class="spinner-color--{{ color }}"
    diameter="24"
    mode="indeterminate"
  ></mat-progress-spinner>
  <mat-icon *ngIf="!loading">{{ icon }}</mat-icon>
</button>
